import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const SaveAndCloseButton = forwardRef(({ title = 'Save & Close', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='save-and-close-button'
    type='submit'
    title={title}
    {...props}
  />
)); 

export default SaveAndCloseButton;
